const page_schema = {
	"tiers": [
		{
			"name": "Downstream Analysis",
			"type": "checkbox",
			"id": "downstream-analysis",
			"class_name": "tags",
			"child_name": "downstream-analysi",
			"options": [
				{
					"name": "Bisulfite PCR",
					"id": "bisulfite-pcr"
				},
				{
					"name": "Methylation-Specific PCR",
					"id": "methylation-specific-pcr"
				},
				{
					"name": "NGS Library Optimization",
					"id": "ngs-library-optimization"
				},
				{
					"name": "Spike-in or In Situ Control",
					"id": "spike-in-or-in-situ-control"
				},
				{
					"name": "Methylation Assay Calibration",
					"id": "methylation-assay-calibration"
				},
			]
		},
		{
			"name": "Methylation Percentage",
			"type": "checkbox",
			"id": "methylation-percentages",
			"class_name": "tags",
			"child_name": "methylation-percentage",
			"options": [
				{
					"name": "0% Methylation",
					"id": "0-methylation"
				},
				{
					"name": "100% Methylation",
					"id": "100-methylation"
				},
				{
					"name": "0% and 100% Methylation",
					"id": "0-and-100-methylation"
				},
				{
					"name": "Physiological Levels",
					"id": "physiological-levels"
				},
			]
		},
	],
	"filters": [],
	"products": {
		"Universal Methylated Human DNA Standard": {
			"title": "Universal Methylated Human DNA Standard",
			"catalogNumbers": "D5011",
			"description": "The Universal Methylated DNA Standards are designed to be used as positive controls to assess the efficiency of DNA bisulfite conversion in human and mouse models. The control DNA can be run in parallel with samples to monitor the bisulfite conversion reaction. The primer sets are designed to amplify a fragment of the supplied DNA from the respective species following bisulfite treatment.",
			"handle": "/products/universal-methylated-dna-standard",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5011_Universal-Methylated-Human-DNA-Standard.jpg?v=1628532409&width=600",
			"generalIndex": "998",
			"id": "universal-methylated-dna-standard",
			"tags": [
				"bisulfite-pcr",
				"ngs-library-optimization",
				"100-methylation",
			],
			filters: []
		},
		"Universal Methylated Mouse DNA Standard": {
			"title": "Universal Methylated Mouse DNA Standard",
			"catalogNumbers": "D5012",
			"description": "The Universal Methylated DNA Standards are designed to be used as positive controls to assess the efficiency of DNA bisulfite conversion in human and mouse models. The control DNA can be run in parallel with samples to monitor the bisulfite conversion reaction. The primer sets are designed to amplify a fragment of the supplied DNA from the respective species following bisulfite treatment.",
			"handle": "/products/universal-methylated-dna-standard",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5011_Universal-Methylated-Human-DNA-Standard.jpg?v=1628532409&width=600",
			"generalIndex": "998",
			"id": "universal-methylated-dna-standard",
			"tags": [
				"bisulfite-pcr",
				"ngs-library-optimization",
				"100-methylation",
			],
			filters: []
		},
		"Human Methylated & Non-Methylated (WGA) DNA Set": {
			"title": "Human Methylated & Non-Methylated (WGA) DNA Set",
			"catalogNumbers": "D5013, D5013-1, D5013-2",
			"description": "The Human WGA Methylated & Non-methylated DNA Set consists of two control DNAs (non-methylated and methylated) along with a set of specifically designed primers that can be used in conjunction with the EZ DNA Methylation, EZ DNA Methylation-Gold, EZ DNA Methylation-Direct, and EZ DNA Methylation-Lightning kits from Zymo Research to assess the efficiency of bisulfite-mediated conversion of DNA. The Human WGA Methylated & Non-methylated DNA Set is generated using phi29 DNA polymerase based whole genome amplification techniques from HCT116 DKO cell line derived genomic DNA (Human HCT116 DKO Non-methylated DNA). The Human WGA Methylated DNA is Human WGA Non-methylated DNA that has been enzymatically methylated at all double-stranded CG dinucleotides using M.SssI methyltransferase and can be used as a positive control for DNA methylation analysis.",
			"handle": "/products/human-methylated-non-methylated-wga-dna-set-dna-w-primers",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5013_Human-WGA-Methylated-and-Non-Methylated-DNA-Set.jpg?v=1628532406&width=600",
			"generalIndex": "998",
			"id": "human-methylated-non-methylated-wga-dna-set-dna-w-primers",
			"tags": [
				"bisulfite-pcr",
				"methylation-specific-pcr",
				"0-and-100-methylation",
			],
			filters: []
		},
		"Human Methylated & Non-methylated DNA set": {
			"title": "Human Methylated & Non-methylated DNA set",
			"catalogNumbers": "D5014, D5014-1, D5014-2",
			"description": "The Human Methylated & Non-methylated DNA Set consists of two DNA controls (a CpG-methylated human DNA standard and a non-methylated human DNA standard), with a set of specifically designed primers that can be used in conjunction with the EZ DNA Methylation family of products. This DNA set can be included as a positive and negative control to assess the efficiency of bisulfite conversion of DNA. The non-methylated human DNA is purified from the HCT116 DKO cell line, which contains genetic knockouts of both DNA methyltransferases DNMT1 (-/-) and DNMT3b (-/-). The methylated DNA standard is purified HCT116 DKO DNA that has been enzymatically methylated at CpG sites.",
			"handle": "/products/human-methylated-non-methylated-dna-set-dna-w-primers",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5014_Human-Methylated-and-Non-Methylated-DNA-Set.jpg?v=1628532405&width=600",
			"generalIndex": "998",
			"id": "human-methylated-non-methylated-dna-set-dna-w-primers",
			"tags": [
				"bisulfite-pcr",
				"methylation-specific-pcr",
				"ngs-library-optimization",
				"methylation-assay-calibration",
				"0-and-100-methylation",
			],
			filters: []
		},
		"Bisulfite-Converted Universal Methylated Human DNA Standard": {
			"title": "Bisulfite-Converted Universal Methylated Human DNA Standard",
			"catalogNumbers": "D5015",
			"description": "The Bisulfite-Converted Universal Methylated Human DNA Standard is designed to be used as a control for DNA bisulfite conversion and downstream analyses including PCR, MSP, and other amplification-based assays. This DNA is identical to our Universal Methylated Human DNA Standard, but has been bisulfite-converted using the EZ DNA Methylation - Direct (D5020) kit. This product is provided as a 20 ng/µl solution and contains enough for 50 reactions. The primer set included with the standard has been designed and validated to amplify a segment of the bisulfite-converted DNA.",
			"handle": "/products/bisulfite-converted-universal-methylated-human-dna-standard",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5015_Bisulfite-Converted-Universal-Methylated-HUman-DNA-Standard.jpg?v=1628532402&width=600",
			"generalIndex": "998",
			"id": "bisulfite-converted-universal-methylated-human-dna-standard",
			"tags": [
				"bisulfite-pcr",
				"100-methylation",
			],
			filters: []
		},
		"E. Coli Non-Methylated Genomic DNA": {
			"title": "E. Coli Non-Methylated Genomic DNA",
			"catalogNumbers": "D5016",
			"description": "E. coli non-methylated genomic DNA is from a Dam- and Dcm- strain (ER2925) of E. coli. It works perfectly as a negative control for DNA methylation analyses requiring DNA with absolutely no methylation.",
			"handle": "/products/e-coli-non-methylated-genomic-dna",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5016_E-Coli-Non-Methylated-Genomic-DNA.jpg?v=1628532395&width=600",
			"generalIndex": "998",
			"id": "e-coli-non-methylated-genomic-dna",
			"tags": [
				"bisulfite-pcr",
				"ngs-library-optimization",
				"spike-in-or-in-situ-control",
				"methylation-assay-calibration",
				"0-methylation",
			],
			filters: []
		},
		"Methylated & Non-methylated pUC19 DNA Set": {
			"title": "Methylated & Non-methylated pUC19 DNA Set",
			"catalogNumbers": "D5017",
			"description": "The Methylated & Non-methylated pUC19 DNA Set consists of control DNAs and a set of specifically designed primers. The set is ideal as a “spike-in” control to assess bisulfite conversion efficiency within the same reaction as the sample, or to produce known mixtures of methylated and non-methylated DNA for assay calibration. The non-methylated pUC19 DNA is pUC19 isolated from a methylation-negative strain of bacteria (Dam-, Dcm-), and the methylated pUC19 DNA is pUC19 enzymatically methylated at all cytosines in the dinucleotide sequence 5'...CpG...3' by CpG Methylase.",
			"handle": "/products/methylated-non-methylated-puc19-dna-set",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5017_Methylated-and-Non-Methylated-pUC19-DNA-Set.jpg?v=1628532408&width=600",
			"generalIndex": "998",
			"id": "methylated-non-methylated-puc19-dna-set",
			"tags": [
				"bisulfite-pcr",
				"spike-in-or-in-situ-control",
				"methylation-assay-calibration",
				"0-and-100-methylation",
			],
			filters: []
		},
		"Human Matched DNA Set": {
			"title": "Human Matched DNA Set",
			"catalogNumbers": "D5018, D5018-1, D5018-2",
			"description": "The Human Matched DNA Set is a set of organ specific human genomic DNAs originating from a single individual. This set is an ideal control for detection and/or quantification methods against 5-methylcytosine and 5-hydroxymethylcytosine as both modified cytosines are present at physiologically relevant levels and loci. The levels of 5-hydroxymethylcytosine and 5-methylcytosine within the Human Matched DNA Set have been quantified via LC/MS.",
			"handle": "/products/human-matched-dna-set",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5018_Human-Matched-DNA-Set.jpg?v=1628532387&width=600",
			"generalIndex": "998",
			"id": "human-matched-dna-set",
			"tags": [
				"bisulfite-pcr",
				"ngs-library-optimization",
				"methylation-assay-calibration",
				"physiological-levels",
			],
			filters: []
		},
		"Mouse 5-hmC & 5-mC DNA Set": {
			"title": "Mouse 5-hmC & 5-mC DNA Set",
			"catalogNumbers": "D5019, D5019-1, D5019-2, D5019-3, D5019-4",
			"description": "The Mouse 5-hmC & 5-mC DNA Set is a set of organ specific mouse genomic DNAs isolated from a pool of 8-10 week old Swiss Webster mice. This genomic DNA set is an ideal control for detection and/or quantification methods against 5-methylcytosine and 5-hydroxymethylcytosine as both modified cytosines are present at physiologically relevant levels and loci. The levels of 5-mC and 5-hmC within the Mouse 5-hmC & 5-mC DNA Set have been precisely quantified by mass spectrometry (LC/MS) and been validated to be consistent by ELISA.",
			"handle": "/products/mouse-5hmc-5mc-dna-set",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5019_Mouse-hmC-and-5-mC-DNA.jpg?v=1628532404&width=600",
			"generalIndex": "998",
			"id": "mouse-5hmc-5mc-dna-set",
			"tags": [
				"bisulfite-pcr",
				"ngs-library-optimization",
				"methylation-assay-calibration",
				"physiological-levels",
			],
			filters: []
		},
		"5-Methylcytosine & 5-Hydroxymethylcytosine DNA Standard Set ": {
			"title": "5-Methylcytosine & 5-Hydroxymethylcytosine DNA Standard Set ",
			"catalogNumbers": "D5405",
			"description": "The 5-Methylcytosine & 5-Hydroxymethylcytosine DNA Standard Set is a set of three standards that are linear dsDNA at a length of 897 bp. All DNA standards have the same sequence (see protocol for sequence), the only difference being that each standard contains either 100% unmodified cytosines, 5-methylcytosines, or 5-hydroxymethylcytosines. Since the sequence and extent of cytosine modification is known, this DNA standard set is ideal for use in calibration of various applications intended for quantitation of cytosine modifications.",
			"handle": "/products/5-methylcytosine-5-hydroxymethylcytosine-dna-standard-set",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5405_5-mC_20_205-hmC_20DNA_20Standard_20Set.png?v=1628532408&width=600",
			"generalIndex": "998",
			"id": "5-methylcytosine-5-hydroxymethylcytosine-dna-standard-set",
			"tags": [
				"spike-in-or-in-situ-control",
				"0-and-100-methylation",
			],
			filters: []
		},
		"Zymo-Seq Methyl Spike-in Control": {
			"title": "Zymo-Seq Methyl Spike-in Control",
			"catalogNumbers": "D5500",
			"description": "Zymo-Seq Methyl Spike-in Control is comprised of six unique double-stranded synthetic amplicons (180-200 bp) with distinct sequences derived from the E. coli K12 genome, and each amplicon represents a different CpG methylation level ranging from 0% to 100%. ",
			"handle": "/products/zymo-seq-methyl-spike-in-control",
			"navigation_image": "https://stage.zymoresearch.com/cdn/shop/files/D5500-Zymo-Seq_Methyl_Spike-in_Control_800x@2x.jpg",
			"generalIndex": "998",
			"id": "zymo-seq-methyl-spike-in-control",
			"tags": [
				"ngs-library-optimization",
				"spike-in-or-in-situ-control",
				"methylation-assay-calibration",
				"0-and-100-methylation",
			],
			filters: []
		},
		"CpG Methylase (M. Sssl)": {
			"title": "CpG Methylase (M. Sssl)",
			"catalogNumbers": "E2010, E2011",
			"description": "CpG Methylase (M. SssI) ensures complete, in vitro methylation of DNA for methylation analysis.",
			"handle": "/products/cpg-methylase-m-sssl",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2010_CpG-Methylase.jpg?v=1628532396&width=600",
			"generalIndex": "998",
			"id": "cpg-methylase-m-sssl",
			"tags": [
				"100-methylation",
			],
			filters: []
		},
		"Methylated & Hydroxymethylated Nucleotides": {
			"title": "Methylated & Hydroxymethylated Nucleotides",
			"catalogNumbers": "D1035, D1030",
			"description": "5-Methyl dCTP can be used in nucleotide mixtures to generate PCR amplicons using ZymoTaq, QuestTaq, or other DNA polymerases.",
			"handle": "/products/5-methyl-dctp",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D1035_Methylated-and-Hydroxymethylated-Nucleotides.jpg?v=1628532399&width=600",
			"generalIndex": "998",
			"id": "5-methyl-dctp",
			"tags": [
				"100-methylation",
			],
			filters: []
		},
		"dNTP Solutions": {
			"title": "dNTP Solutions",
			"catalogNumbers": "D1000-1, D1000, D1020, D1010, D1015, D1005",
			"description": "dNTP Mix is a ready-to-use, ultra pure nucleotide mix that can be used to generate PCR amplicons using ZymoTaq, QuestTaq or other DNA polymerases.",
			"handle": "/products/dntp-mix",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D1000_dNTPs.jpg?v=1628532404&width=600",
			"generalIndex": "998",
			"id": "dntp-mix",
			"tags": [
				"0-methylation",
			],
			filters: []
		},
	}
}